/* eslint-disable max-statements */
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { selectCurrentEmpid, selectCurrentUserManagerLevel, selectIsPseudoSupervisor } from '../../../pages/login/authSlice';
import { datetimeToDate } from '../../../utils/dateFormat';
import { useGetDirectReporteesQuery } from '../coachingHistoryGrid/coachingHistoryGridSlice';
import { ProgressStats } from './progressStats/ProgressStats';
import { ShoutOutCarousel } from './shoutOutCarousel/ShoutOutCarousel';
import { ToDoGrid } from './toDoGrid/ToDoGrid';
import { SearchedEmployeType } from '../revGen/type';
import { GetTeamOptions, getRole } from './toDoView-service';
import {
    useGetShoutOutCarouselQuery,
    useGetToDoViewQuery,
    useUpdateToDoStatusMutation,
} from './toDoViewSlice';
import { EmployeeSearchPopUp } from '../employeeSearchPopUp/EmployeeSearchPopUp';

interface todoProps {
    teamOptionId?: string;
    entityId?: string;
}
export const ToDoView = ({ teamOptionId, entityId }: todoProps) => {
    //*****************  KanBan Alternative ************************************ //
    const date = new Date();
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const [selectedFromDate, setSelectedFromDate] = useState<Date>(firstDay);
    const [selectedToDate, setSelectedToDate] = useState<Date>(lastDay);
    const loggedUser = useSelector(selectCurrentEmpid);
    const [teamOptions, setTeamOptions] = useState<any>([]);
    const [selectedTeamOption, setSelectedTeamOption] = useState<string>('');
    const userMngrRole = useSelector(selectCurrentUserManagerLevel);
    const isPseudoSupervisor = useSelector(selectIsPseudoSupervisor);
    const [empNo, setEmpNo] = useState<string>('');
    //const [searchOracleId, setSearchOracleId] = useState<any>();
    const [toDoViewData, setToDoViewData] = useState<any>([]);
    const [UpdateToDoStatus] = useUpdateToDoStatusMutation();
    const [searchVisible, setSearchVisible] = useState<boolean>(false);
    const [searchedEmployee, setSearchedEmployee] = useState<SearchedEmployeType>({
        'employee_name': '',
        'employee_number': '',
        'location': '',
        'job_title': '',
    });

    const hideDate = false;

    const [selectedEmpList, setSelectedEmpList] = useState<any>();
    const [selectedEmp, setSelectedEmp] = useState<string>('');
    const teamSelected = () => {
        if (selectedTeamOption === 'myActivity') return 'mytodos'
        if (selectedTeamOption === 'myTeamActivity') return 'myteam'
        if (selectedTeamOption === 'search') return selectedTeamOption
        return null
    }
    const { data: coachingTodoView } = useGetToDoViewQuery(
        {
            employeeNumber: loggedUser,
            searchOracleId: empNo,
            type: teamSelected(),
            userRole: getRole(userMngrRole, isPseudoSupervisor),
            fromDate: datetimeToDate(selectedFromDate),
            toDate: datetimeToDate(selectedToDate),
        },
        {
            skip:
                !selectedFromDate ||
                !selectedToDate ||
                !selectedTeamOption ||
                !loggedUser ||
                !empNo ||
                selectedFromDate > selectedToDate,
        }
    );


    const { data: shoutOuts } = useGetShoutOutCarouselQuery({
        employeeNumber: loggedUser,
        employeeRole: getRole(userMngrRole, isPseudoSupervisor),
    });
    const { data: directReportees } = useGetDirectReporteesQuery(
        {
            employeeNo: parseInt(loggedUser, 10),
        },
        {
            skip: !loggedUser,
        }
    );

    useEffect(() => {
        if (teamOptionId) {
            if (teamOptionId === '1') {
                setSelectedTeamOption('myActivity');
            }
            else if (teamOptionId === '2') {
                setSelectedTeamOption('myTeamActivity');
            }
        }
        else {
            const selecedTeam = localStorage.getItem('selectedTeam');
            if (selecedTeam && teamOptions.some((item: any) => item.code === selecedTeam)) {
                setSelectedTeamOption(selecedTeam);
            } else {
                setSelectedTeamOption('myActivity')
            }
            const searchedUserString: string | null = localStorage.getItem('searchedUser');
            if (selecedTeam === 'search') {
                if (searchedUserString) {
                    const searchedUser: SearchedEmployeType = JSON.parse(searchedUserString);
                    setTimeout(() => {
                        //setSearchOracleId(searchedUser.employee_number);
                        setSearchedEmployee(searchedUser);
                        setEmpNo(searchedUser.employee_number);
                    }, 50);
                }
                else
                    setSearchVisible(true);
            }
        }

    }, [directReportees, teamOptions, teamOptionId]);
    useEffect(() => {
        if (selectedTeamOption === 'myTeamActivity') {
            if (directReportees?.data?.length > 0) {
                const employeeNames = directReportees.data.map((employee: any) => ({
                    label: employee.employee_name,
                    value: employee.employee_number,
                }));
                employeeNames.unshift({ label: 'All', value: 'all' });
                setSelectedEmpList(employeeNames);
                const searchedTeamMemberValue = localStorage.getItem('searchedTeamMember');
                if (searchedTeamMemberValue) {
                    const data = employeeNames.find((item: any) => item.value === parseInt(searchedTeamMemberValue, 10))
                    if (data) {
                        setSelectedEmp(data?.value);
                        setEmpNo(data?.value);

                    } else {
                        setSelectedEmp('all');

                    }
                } else {
                    setSelectedEmp('all');
                }



            } else {
                setSelectedEmpList([]);
                toast.info('No Direct reportees found');
            }
        }
    }, [directReportees, selectedTeamOption]);
    const updateToDoStatusApi = async (id: number, status: string): Promise<boolean> => {
        const request = {
            coachingToDoId: id,
            toDoStatus: status,
            employeeNumber: loggedUser,
        };
        let apiUpdate = false;

        try {
            const res = await UpdateToDoStatus(request).unwrap();
            if (res?.data) {
                toast.success('Status updated successfully');
                apiUpdate = true;
            } else {
                toast.error('Something went wrong, please try again');
            }
        } catch (error) {
            console.log(error);
            toast.error('Something went wrong, please try again');
        }

        return apiUpdate;
    };

    const updateToDoViewData = (props: any, value: any) => {
        /*eslint-disable camelcase*/
        if (!updateToDoStatusApi(props?.rowData.coaching_to_do_id, value)) return;
        setToDoViewData((prevState: any) => {
            const idx = prevState.findIndex(
                (data: any) => data.coaching_to_do_id === props?.rowData.coaching_to_do_id
            );
            if (idx < 0) return prevState;
            const updatedToDoView = [...prevState];
            const updatedItem = { ...updatedToDoView[idx], coaching_to_do_status_name: value };
            updatedToDoView[idx] = updatedItem;
            return updatedToDoView;
        });
        /*eslint-enable camelcase*/
    };

    useEffect(() => {
        let filteredData = coachingTodoView?.data?.length > 0 ? coachingTodoView?.data : [];
        if (selectedTeamOption === 'myTeamActivity') {
            filteredData = coachingTodoView?.data?.filter(
                (item: any) => item?.employee_number !== loggedUser.toString()
            );
        }
        setToDoViewData(filteredData);
    }, [coachingTodoView]);

    const statusNames = useMemo(
        () => toDoViewData?.map((item: any) => item?.coaching_to_do_status_name),
        [toDoViewData]
    );

    useEffect(() => {
        if (selectedFromDate && selectedToDate && selectedFromDate > selectedToDate) {
            toast.warning('From date should not be greater than Todate');
        }
    }, [selectedFromDate, selectedToDate]);

    // useEffect(() => {
    //     setTeamOptions(GetTeamOptions(userMngrRole,isPseudoSupervisor));
    //     if (
    //         (getRole(userMngrRole,isPseudoSupervisor) === 'director' || getRole(userMngrRole,isPseudoSupervisor) === 'manager') &&
    //         selectedTeamOption === 'search'
    //     ) {
    //         setSearchOracleId('');
    //         setEmpNo('');
    //     } else setEmpNo(loggedUser);
    // }, [loggedUser, selectedTeamOption]);
    useEffect(() => {
        setTeamOptions(GetTeamOptions(userMngrRole, isPseudoSupervisor));
    }, [loggedUser]);
    useEffect(() => {
        const searchedUserString: string | null = localStorage.getItem('searchedUser');
        if (selectedTeamOption === 'search') {
            if (searchedUserString) {
                //const searchedUser: SearchedEmployeType = JSON.parse(searchedUserString);
            }
            else {
                setEmpNo('');
                setSearchVisible(true);
            }
        }
        else if (selectedTeamOption === '')
            setToDoViewData([]);
        else
            setEmpNo(loggedUser);
    }, [selectedTeamOption]);

    const cachedTodoViewDaata = useMemo(() => {
        //if (selectedEmp === '' ||selectedEmp === 'all' || selectedEmp === 'myActivity') 
        return toDoViewData;
        // return toDoViewData.filter(
        //     (item: any) =>
        //         item.employee_number === `${selectedEmp === 'search' ? searchOracleId : selectedEmp}`
        // );
    }, [toDoViewData, selectedEmp]);
    const handleReset = () => {
        setSelectedTeamOption('');
        setSearchVisible(false);
        setEmpNo('');
        localStorage.setItem('selectedTeam', '');
    };
    useEffect(() => {
        if (searchedEmployee?.employee_number && selectedTeamOption === 'search') {
            setEmpNo(searchedEmployee?.employee_number);
        }
    }, [searchedEmployee])
    return (
        <div className="card mt-3 ms-0 me-0 shadow bg-body rounded border-0">
            <div className='quote'>
                <p className='margin0  quote-text'>Ask yourself if what you&apos;re doing today is getting you closer to where you want to be tomorrow</p>
                <p className='quote-author'>- Paulo Coelho</p>
            </div>
            <div className="row d-flex mt-4 ms-2">
                {hideDate && (
                    <div className="mb-3">
                        {' '}
                        <div className="col-md-2">
                            <h6>From</h6>
                            <Calendar
                                id="fromDate"
                                value={selectedFromDate}
                                onChange={(e: any) => setSelectedFromDate(e.value)}
                                showIcon
                                dateFormat="dd-M-yy"
                                className="custom-calendar"
                            />
                        </div>
                        <div className="col-md-2">
                            <h6 style={{ fontWeight: '600', fontSize: '16px' }}>To</h6>
                            <Calendar
                                id="toDate"
                                value={selectedToDate}
                                onChange={(e: any) => setSelectedToDate(e.value)}
                                showIcon
                                dateFormat="dd-M-yy"
                                className="custom-calendar"
                            />
                        </div>
                    </div>
                )}
                {getRole(userMngrRole, isPseudoSupervisor) !== 'associate' && (
                    <div className="col-md-3">
                        <h6 style={{ fontWeight: '600', fontSize: '16px' }}>Select Team</h6>
                        <Dropdown
                            value={selectedTeamOption}
                            onChange={(event) => {
                                localStorage.removeItem('searchedUser');
                                localStorage.setItem('selectedTeam', event.target.value);
                                setSelectedEmp(event.target.value);
                                setSelectedTeamOption(event.target.value);
                            }}
                            options={teamOptions}
                            optionLabel={'name'}
                            optionValue={'code'}
                            placeholder="Select Team"
                            // className="w-full md:w-14rem "
                            className="custom-dropdown"
                            disabled={getRole(userMngrRole, isPseudoSupervisor) === 'associate'}
                        />
                    </div>
                )}
                {selectedTeamOption === 'myTeamActivity' && (
                    <div className="col-md-3">
                        <div className="content">
                            <label htmlFor="selectedEmp">Select Employee</label>
                            <Dropdown
                                id="selectedEmp"
                                name="Select Employee"
                                placeholder="Select Employee"
                                // className="rounded-start"
                                className="custom-dropdown"
                                options={selectedEmpList}
                                optionValue={'value'}
                                optionLabel={'label'}
                                value={selectedEmp}
                                onChange={(event) => {
                                    localStorage.setItem('searchedTeamMember', event.target.value);
                                    setSelectedEmp(event.target.value);
                                    if (event.target.value === 'all') setEmpNo(loggedUser);
                                    else setEmpNo(event.target.value);
                                }}
                            />
                        </div>
                    </div>
                )}
                {getRole(userMngrRole, isPseudoSupervisor) !== 'associate' && selectedTeamOption === 'search' && (
                    <div className="col-md-3">
                        <Button
                            label="Reset"
                            className="btn-secondary mt-4"
                            onClick={handleReset}
                        />
                    </div>
                )}
            </div>
            <div className="card-body p-0 align-middle text-center table">
                <div className="row d-flex me-2 mb-2">
                    <div className="col-md-4 mt-4">
                        <ProgressStats statusNames={statusNames} />
                    </div>
                    <div className="col-md-8 mt-4">
                        <ShoutOutCarousel shoutOuts={shoutOuts?.data || []} />
                    </div>
                </div>

                <ToDoGrid
                    coachingToDoViewData={cachedTodoViewDaata}
                    updateToDoViewData={updateToDoViewData}
                    entityId={entityId}
                />
            </div>
            {searchVisible && (
                <EmployeeSearchPopUp
                    visible={searchVisible}
                    searchedEmployee={searchedEmployee}
                    setVisible={setSearchVisible}
                    setSelectedTeam={setSelectedTeamOption}
                    setSearchedEmployee={setSearchedEmployee}
                />
            )}
        </div>
    );
};
